import { render, staticRenderFns } from "./ProjectDocumentAccessScopePlaceholder.vue?vue&type=template&id=1097f4b7"
import script from "./ProjectDocumentAccessScopePlaceholder.vue?vue&type=script&lang=ts"
export * from "./ProjectDocumentAccessScopePlaceholder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1097f4b7')) {
      api.createRecord('1097f4b7', component.options)
    } else {
      api.reload('1097f4b7', component.options)
    }
    module.hot.accept("./ProjectDocumentAccessScopePlaceholder.vue?vue&type=template&id=1097f4b7", function () {
      api.rerender('1097f4b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/skeletonPlaceholder/components/ProjectDocumentAccessScopePlaceholder.vue"
export default component.exports